import React from 'react';
import { BookOpenIcon, ClipboardListIcon, LayersIcon, MessageCircleIcon, TargetIcon, TimerIcon } from 'lucide-react';
import { benefits } from '../data/salesCopy';
import type { Benefit } from '../types/sales';
const icons: Record<Benefit['icon'], React.ElementType> = {
  classes: LayersIcon,
  poses: BookOpenIcon,
  target: TargetIcon,
  voice: MessageCircleIcon,
  plan: ClipboardListIcon,
  time: TimerIcon
};
export function BenefitsSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-39" data-mp="3dr3tbfa7p4n1">
      <div className="mx-auto max-w-4xl" data-id="element-40" data-mp="3dsolwzcyudi9">
        <div className="text-center" data-id="element-41" data-mp="2zrlxwh2eut4p">
          <h2 className="font-serif text-lg font-extrabold uppercase leading-tight text-brand-charcoal/70 sm:text-xl" data-id="element-42" data-mp="2zsnm7n8ftc4d">
            This isn't just about having more Yin Yoga sequences
          </h2>
          <p className="mt-1 font-serif text-xl font-extrabold uppercase leading-tight text-brand-sage sm:text-3xl" data-id="element-43" data-mp="y1aiv2m4bcaf">
            It's about having a complete teaching system.
          </p>
          <span className="mx-auto mt-2 block h-0.5 w-14 bg-brand-gold" data-id="element-44" data-mp="2be49pspiph6b" />
        </div>

        <div className="mt-5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-45" data-mp="27e3tq3mrsxx5">
          {benefits.map(benefit => {
          const Icon = icons[benefit.icon];
          return <div key={benefit.title} className="flex flex-col rounded-lg border border-brand-sand/70 bg-white p-3 shadow-sm" data-id="element-46" data-mp="2g65vq6chmm9j">
                <Icon className="h-5 w-5 text-brand-clay" aria-hidden="true" data-id="element-47" data-mp="1si4rh9mcdrzx" />
                <h3 className="mt-1.5 text-[13px] font-extrabold uppercase leading-tight tracking-wide text-brand-sage sm:text-sm" data-id="element-48" data-mp="22f0q8nmfuzra">
                  {benefit.title}
                </h3>
                <p className="mt-1 text-[12.5px] font-medium leading-snug text-brand-charcoal/80 sm:text-[13.5px]" data-id="element-49" data-mp="3dtea7he2mv21">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}